<template>
    <div>
        <question-page :exam="exam" :material="material"/>
        <div style="text-align: right; margin-bottom: 20px;">
            <a-button type="primary" icon="plus" size="small" @click="() => { creating = true; question = null }">Soal Baru</a-button>
        </div>

        <a-card type="inner" size="small">
            <a-descriptions>
                <a-descriptions-item label="Jumlah soal">
                    <strong>{{ items.total }}</strong>
                </a-descriptions-item>
            </a-descriptions>
            <a-skeleton :loading="loading">
                <a-table
                    class="pcp-table"
                    rowKey="hash"
                    :dataSource="items.data"
                    :pagination="items"
                    @change="tableChanged">

                    <a-table-column key="excerpt" title="Excerpt" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <strong>{{ record.content }}</strong>
                        </template>
                    </a-table-column>

                    <a-table-column key="order" title="Order" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <a-tag type="primary">{{ record.order }}</a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column key="random" title="Random" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <a-tag type="primary">{{ record.answer_in_random_order ? 'YES' : 'NO' }}</a-tag>
                        </template>
                    </a-table-column>

                    <a-table-column key="action" title="Action" className="align-center text-small text-left">
                        <template slot-scope="record">
                            <a-tooltip title="Edit material">
                                <a-button size="small" type="primary" icon="edit" @click="() => { creating = true; question = record }"/>
                            </a-tooltip>
                            <a-tooltip title="Jawaban">
                                <a-button style="margin-left: 4px;margin-top:3px;margin-bottom:3px"
                                size="small" icon="eye" @click="answer(record)" :loading="processing" :disabled="processing"/>
                            </a-tooltip>
                        </template>
                    </a-table-column>
                </a-table>
            </a-skeleton>
        </a-card>
        <a-drawer :width="720" placement="right" :closable="true" :visible="creating" @close="() => creating = false" :destroyOnClose="true">
            <question-form :exam="exam" @saved="getItems" :question="question" />
        </a-drawer>
        <a-modal v-model="visible" :title="title" @ok="handleOk" :destroyOnClose="true" :closable="false" width="40%">
            <a-row v-for="(answer, index) in answers" :key="index" :gutter="16">
                <a-col :span="4">
                    <h3 style="text-align: center;">{{ String.fromCharCode(index + 64 + 1) }}</h3>
                </a-col>
                <a-col :span="14" >
                    {{ answer.content}} <a-divider/>
                </a-col>
                <a-col :span="6" style="text-align: center">
                    <a-icon type="check-square" theme="twoTone" two-tone-color="#52c41a" v-if="answer.is_correct_answer" style="font-size: 24px;" />
                    <a-checkbox :disabled="true" v-else />
                </a-col>
            </a-row>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: {
        exam: {
            type: Object
        }
    },
    data() {
        return {
            current: 1,
            items: null,
            loading: false,
            creating: false,
            question: null,
            processing: false,
            visible: false,
            answers: [],
            title: null,
            filters: {
                per_page: 20,
                q: null,
                page: 1,
            },
            material:{
                category: {
                    modul: {}
                }
            }
        }
    },
    computed: {
        perPage: function () {
            return Number(this.items.per_page)
        }
    },
    created() {
        this.items = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = false
            this.$http.get(this.routeUri('api.material-exam.questions', { exam: this.exam.id }), { params: {...this.filters} })
                .then((r) => {
                    this.items = r.data.exam_questions
                    this.items.pageSize = Number(this.items.per_page)
                    this.material = r.data.material
                })
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.loading = false)
        },
        tableChanged(pagination) {
            this.filters.page = Number(pagination.current)
            this.pushState(this.filters)
            this.getItems()
        },
        answer(record) {
            this.processing = false
            this.$http.get(this.routeUri('api.material-exam.questions.answers', { exam: this.exam.id, question: record.hash }))
                .then((r) => this.answers = r.data.answers)
                .catch((e) => this.handleXhrError(e))
                .finally(() => this.processing = false)

            this.title = record.content
            this.visible = true
        },
        handleOk(e) {
            this.visible = false
        },
    }
}
</script>
